import { render, staticRenderFns } from "./patientCase.vue?vue&type=template&id=321658e4"
import script from "./patientCase.vue?vue&type=script&lang=js"
export * from "./patientCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports